import type { Race } from './types';

/** Race the app opens on before anyone has picked one. */
export const DEFAULT_RACE_ID = 'chicago-2026';

// Generated from context-chicago/race-catalog-research.md (researched 2 Oct 2026).
// Races whose next date is unannounced are left out; where only the start time is unannounced,
// startTime carries the previous edition's first wave (or an 08:00 placeholder) and startTimeConfirmed is false.
export const races: Race[] = [
  {
    id: 'twin-cities-2026',
    name: 'Medtronic Twin Cities Marathon',
    city: 'Minneapolis-Saint Paul',
    country: 'USA',
    date: '2026-10-04',
    dateConfirmed: true,
    startTime: '08:00',
    timezone: 'America/Chicago',
    lat: 44.975,
    lng: -93.262,
    url: 'https://www.tcmevents.org/alleventsandraces/medtronictwincitiesmarathonweekend/medtronictwincitiesmarathon',
    finishers: 7025,
    knownFor: '"Most beautiful urban marathon": lakes, Mississippi River and fall colour from Minneapolis to the State Capitol, with a Summit Ave grind late',
  },
  {
    id: 'chicago-2026',
    name: 'Bank of America Chicago Marathon',
    city: 'Chicago',
    country: 'USA',
    date: '2026-10-11',
    dateConfirmed: true,
    startTime: '07:35',
    timezone: 'America/Chicago',
    lat: 41.8807,
    lng: -87.6206,
    url: 'https://www.chicagomarathon.com',
    finishers: 54200,
    major: true,
    knownFor: 'Flattest major and a classic PB course through 29 neighbourhoods; cool October mornings and huge crowds',
  },
  {
    id: 'melbourne-2026',
    name: 'Melbourne Marathon Festival',
    city: 'Melbourne',
    country: 'Australia',
    date: '2026-10-11',
    dateConfirmed: true,
    startTime: '06:15',
    timezone: 'Australia/Melbourne',
    lat: -37.8203,
    lng: 144.9787,
    url: 'https://melbournemarathon.com.au/nike-melbourne-marathon/',
    finishers: 12100,
    knownFor: 'Starts on Batman Ave and finishes with a lap of the MCG turf; one of Australia\'s two biggest marathon fields',
  },
  {
    id: 'perth-2026',
    name: 'Perth Marathon (Perth Running Festival)',
    city: 'Perth',
    country: 'Australia',
    date: '2026-10-11',
    dateConfirmed: true,
    startTime: '06:30',
    timezone: 'Australia/Perth',
    lat: -31.9512,
    lng: 115.889,
    url: 'https://www.wamc.org.au/programme/',
    finishers: 3019,
    knownFor: 'WA Marathon Club\'s 47th Perth Marathon: Optus Stadium start and flat Swan River foreshore paths; beat the spring heat with the early start',
  },
  {
    id: 'amsterdam-2026',
    name: 'TCS Amsterdam Marathon',
    city: 'Amsterdam',
    country: 'Netherlands',
    date: '2026-10-18',
    dateConfirmed: true,
    startTime: '09:00',
    timezone: 'Europe/Amsterdam',
    lat: 52.3433,
    lng: 4.8544,
    url: 'https://www.tcsamsterdammarathon.eu/program',
    finishers: 23300,
    knownFor: 'Flat, fast loop starting and finishing inside the 1928 Olympic Stadium, via the Amstel and the Rijksmuseum underpass; narrow in places',
  },
  {
    id: 'toronto-2026',
    name: 'TCS Toronto Waterfront Marathon',
    city: 'Toronto',
    country: 'Canada',
    date: '2026-10-18',
    dateConfirmed: true,
    startTime: '08:00',
    timezone: 'America/Toronto',
    lat: 43.6595,
    lng: -79.3822,
    url: 'https://www.torontowaterfrontmarathon.com/',
    finishers: 7538,
    knownFor: 'Flat, fast Gold Label lakeshore course; Canada\'s biggest marathon and a classic BQ/PB hunt in cool October air',
  },
  {
    id: 'mcm-2026',
    name: 'Marine Corps Marathon',
    city: 'Arlington / Washington, D.C.',
    country: 'USA',
    date: '2026-10-25',
    dateConfirmed: true,
    startTime: '07:20',
    timezone: 'America/New_York',
    lat: 38.876,
    lng: -77.0595,
    url: 'https://www.marinemarathon.com/',
    finishers: 30127,
    knownFor: '"The People\'s Marathon": no prize money, Marines hand out medals, monuments all the way; you must "Beat the Bridge" at 14 min/mile',
  },
  {
    id: 'frankfurt-2026',
    name: 'Mainova Frankfurt Marathon',
    city: 'Frankfurt',
    country: 'Germany',
    date: '2026-10-25',
    dateConfirmed: true,
    startTime: '10:00',
    timezone: 'Europe/Berlin',
    lat: 50.111,
    lng: 8.659,
    url: 'https://www.frankfurt-marathon.com/en/yourrun/marathon/',
    finishers: 12329,
    knownFor: 'Germany\'s oldest city marathon: flat and fast past the skyscrapers, with a red-carpet finish inside the Festhalle and a civilised 10:00 start',
  },
  {
    id: 'dublin-2026',
    name: 'Irish Life Dublin Marathon',
    city: 'Dublin',
    country: 'Ireland',
    date: '2026-10-25',
    dateConfirmed: true,
    startTime: '08:45',
    timezone: 'Europe/Dublin',
    lat: 53.3348,
    lng: -6.255,
    url: 'https://irishlifedublinmarathon.ie/',
    finishers: 18500,
    knownFor: '"The Friendly Marathon": ballot entry, huge crowds and a long Phoenix Park section; gently undulating with a drag up Roebuck Road around mile 21',
  },
  {
    id: 'nyc-2026',
    name: 'TCS New York City Marathon',
    city: 'New York',
    country: 'USA',
    date: '2026-11-01',
    dateConfirmed: true,
    startTime: '09:10',
    timezone: 'America/New_York',
    lat: 40.603,
    lng: -74.056,
    url: 'https://www.nyrr.org/tcsnycmarathon',
    finishers: 59226,
    major: true,
    knownFor: 'Five boroughs from the Verrazzano Bridge with massive crowds; rolling bridges and a long Staten Island wait make it a poor PB course',
  },
  {
    id: 'auckland-2026',
    name: 'Auckland Marathon',
    city: 'Auckland',
    country: 'New Zealand',
    date: '2026-11-01',
    dateConfirmed: true,
    startTime: '06:00',
    startTimeConfirmed: false,
    timezone: 'Pacific/Auckland',
    lat: -36.832,
    lng: 174.7975,
    url: 'https://www.aucklandmarathon.co.nz/',
    finishers: 2794,
    knownFor: 'Sunrise ferry to the Devonport start, then your one chance to run over the Harbour Bridge, whose climb bites early',
  },
  {
    id: 'athens-2026',
    name: 'Athens Marathon. The Authentic',
    city: 'Athens',
    country: 'Greece',
    date: '2026-11-08',
    dateConfirmed: true,
    startTime: '08:30',
    timezone: 'Europe/Athens',
    lat: 38.152,
    lng: 23.962,
    url: 'https://www.athensauthenticmarathon.gr/',
    finishers: 18900,
    knownFor: 'The original route from Marathon to the marble Panathenaic Stadium; a long climb from ~km 10 to 31 makes it a history race, not a PB',
  },
  {
    id: 'queenstown-2026',
    name: 'Queenstown Marathon',
    city: 'Queenstown',
    country: 'New Zealand',
    date: '2026-11-14',
    dateConfirmed: true,
    startTime: '08:45',
    timezone: 'Pacific/Auckland',
    lat: -44.944,
    lng: 168.818,
    url: 'https://queenstown-marathon.co.nz/',
    finishers: 4000,
    knownFor: 'Saturday race from Millbrook Resort past Arrowtown and Lake Wakatipu, ~70% packed trail: a scenery race, not a PB course',
  },
  {
    id: 'philadelphia-2026',
    name: 'Philadelphia Marathon',
    city: 'Philadelphia',
    country: 'USA',
    date: '2026-11-22',
    dateConfirmed: true,
    startTime: '07:00',
    timezone: 'America/New_York',
    lat: 39.9621,
    lng: -75.1756,
    url: 'https://www.philadelphiamarathon.com/races/marathon/',
    finishers: 12598,
    knownFor: 'Fast, mostly flat late-season BQ course from the Art Museum\'s Rocky steps; sells out by mid-year',
  },
  {
    id: 'florence-2026',
    name: 'Estra Firenze Marathon',
    city: 'Florence',
    country: 'Italy',
    date: '2026-11-29',
    dateConfirmed: true,
    startTime: '08:30',
    timezone: 'Europe/Rome',
    lat: 43.7731,
    lng: 11.256,
    url: 'https://www.firenzemarathon.it/en/',
    finishers: 10195,
    knownFor: 'Start and finish in Piazza del Duomo, via the Cascine park, the Arno and the Renaissance centre; mostly flat but cobbled in the old town',
  },
  {
    id: 'valencia-2026',
    name: 'Maratón Valencia Trinidad Alfonso Zurich',
    city: 'Valencia',
    country: 'Spain',
    date: '2026-12-06',
    dateConfirmed: true,
    startTime: '08:15',
    timezone: 'Europe/Madrid',
    lat: 39.4547,
    lng: -0.35,
    url: 'https://www.valenciaciudaddelrunning.com/en/marathon/',
    finishers: 30523,
    knownFor: 'Europe\'s PB factory: pancake-flat in cool December air, finishing on the blue carpet over the water at the City of Arts and Sciences; sold out, waitlist only',
  },
  {
    id: 'singapore-2026',
    name: 'BYD Singapore International Marathon presented by adidas',
    city: 'Singapore',
    country: 'Singapore',
    date: '2026-12-06',
    dateConfirmed: true,
    startTime: '04:30',
    timezone: 'Asia/Singapore',
    lat: 1.2919,
    lng: 103.8639,
    url: 'https://singaporeinternationalmarathon.com/',
    finishers: 12000,
    knownFor: 'Formerly the Standard Chartered Singapore Marathon; 04:30 start to beat the heat, but humid and slow, so an experience race; new National Stadium finish in 2026',
  },
  {
    id: 'honolulu-2026',
    name: 'JAL Honolulu Marathon',
    city: 'Honolulu',
    country: 'USA',
    date: '2026-12-13',
    dateConfirmed: true,
    startTime: '05:00',
    timezone: 'Pacific/Honolulu',
    lat: 21.295,
    lng: -157.8555,
    url: 'https://www.honolulumarathon.org/our-events/jal-honolulu-marathon',
    finishers: 22745,
    knownFor: 'Pre-dawn fireworks start, Diamond Head and Waikiki, no qualifying time and no cutoff; humid, so not a PB race',
  },
  {
    id: 'houston-2027',
    name: 'Chevron Houston Marathon',
    city: 'Houston',
    country: 'USA',
    date: '2027-01-17',
    dateConfirmed: true,
    startTime: '06:55',
    timezone: 'America/Chicago',
    lat: 29.7628,
    lng: -95.3605,
    url: 'https://www.chevronhoustonmarathon.com/',
    finishers: 9257,
    knownFor: 'Pancake-flat January PB course with cool temps and great crowds; 2027 is already sold out',
  },
  {
    id: 'hong-kong-2027',
    name: 'Standard Chartered Hong Kong Marathon',
    city: 'Hong Kong',
    country: 'Hong Kong',
    date: '2027-01-17',
    dateConfirmed: true,
    startTime: '06:00',
    timezone: 'Asia/Hong_Kong',
    lat: 22.298,
    lng: 114.1722,
    url: 'https://www.hkmarathon.com/race-information',
    finishers: 16000,
    knownFor: 'Hilly highway course over bridges and through tunnels from Nathan Road to Victoria Park; heavily oversubscribed ballot and a strict 6h cutoff',
  },
  {
    id: 'seville-2027',
    name: 'Zurich Maratón de Sevilla',
    city: 'Seville',
    country: 'Spain',
    date: '2027-02-21',
    dateConfirmed: true,
    startTime: '08:30',
    timezone: 'Europe/Madrid',
    lat: 37.3775,
    lng: -5.9905,
    url: 'https://www.zurichmaratonsevilla.es/en/',
    finishers: 16000,
    knownFor: 'Flattest course in Europe in cool February air: the PB-hunter\'s pick; the 20,000 places for 2027 sold out in about a week',
  },
  {
    id: 'osaka-2027',
    name: 'Osaka Marathon',
    city: 'Osaka',
    country: 'Japan',
    date: '2027-02-28',
    dateConfirmed: true,
    startTime: '09:15',
    timezone: 'Asia/Tokyo',
    lat: 34.6867,
    lng: 135.5204,
    url: 'https://www.osaka-marathon.com/2027/en/',
    finishers: 30000,
    knownFor: 'Flat, fast city loop from the Prefectural Government building to Osaka Castle Park; loud crowds, great post-race food, lottery entry',
  },
  {
    id: 'tokyo-2027',
    name: 'Tokyo Marathon',
    city: 'Tokyo',
    country: 'Japan',
    date: '2027-03-07',
    dateConfirmed: true,
    startTime: '09:10',
    timezone: 'Asia/Tokyo',
    lat: 35.6895,
    lng: 139.6917,
    url: 'https://www.marathon.tokyo/en/',
    finishers: 38773,
    major: true,
    knownFor: '20th-anniversary edition; flat, fast and impeccably organised from the Metropolitan Government Building, but a brutal ballot',
  },
  {
    id: 'los-angeles-2027',
    name: 'ASICS Los Angeles Marathon',
    city: 'Los Angeles',
    country: 'USA',
    date: '2027-03-07',
    dateConfirmed: true,
    startTime: '07:00',
    timezone: 'America/Los_Angeles',
    lat: 34.0739,
    lng: -118.24,
    url: 'https://www.lamarathon.com/',
    finishers: 21933,
    knownFor: '"Stadium to the Stars": Dodger Stadium to Century City via Hollywood and Beverly Hills; net downhill but sunny and warm late',
  },
  {
    id: 'barcelona-2027',
    name: 'Zurich Marató Barcelona',
    city: 'Barcelona',
    country: 'Spain',
    date: '2027-03-14',
    dateConfirmed: true,
    startTime: '08:30',
    timezone: 'Europe/Madrid',
    lat: 41.3926,
    lng: 2.1643,
    url: 'https://zurichmaratobarcelona.es/en/',
    finishers: 27000,
    knownFor: 'Flat, fast loop past Sagrada Família and Gaudí landmarks, with a new Passeig de Gràcia start for 2027; warms up quickly by late morning',
  },
  {
    id: 'rome-2027',
    name: 'Acea Run Rome The Marathon',
    city: 'Rome',
    country: 'Italy',
    date: '2027-03-14',
    dateConfirmed: true,
    startTime: '08:30',
    timezone: 'Europe/Rome',
    lat: 41.8918,
    lng: 12.4897,
    url: 'https://www.runromethemarathon.com/',
    finishers: 28000,
    knownFor: 'Start and finish on Via dei Fori Imperiali under the Colosseum; sampietrini cobbles cost time, so a sightseeing race; non-Italians need a RUNCARD and a medical certificate',
  },
  {
    id: 'paris-2027',
    name: 'ASICS Marathon de Paris',
    city: 'Paris',
    country: 'France',
    date: '2027-04-04',
    dateConfirmed: true,
    startTime: '08:00',
    startTimeConfirmed: false,
    timezone: 'Europe/Paris',
    lat: 48.872,
    lng: 2.299,
    url: 'https://www.asicsmarathondeparis.com/en',
    finishers: 57464,
    knownFor: 'Europe\'s biggest marathon, formerly the Schneider Electric Marathon de Paris; the 50th edition has a new organiser and a not-yet-revealed course (coords are the historic Champs-Élysées start)',
  },
  {
    id: 'rotterdam-2027',
    name: 'NN Marathon Rotterdam',
    city: 'Rotterdam',
    country: 'Netherlands',
    date: '2027-04-11',
    dateConfirmed: true,
    startTime: '10:00',
    startTimeConfirmed: false,
    timezone: 'Europe/Amsterdam',
    lat: 51.9108,
    lng: 4.4835,
    url: 'https://nnmarathonrotterdam.nl/en/',
    finishers: 16837,
    knownFor: 'Flat, fast PB course over the Erasmus Bridge straight after the start, finishing on a packed Coolsingel; lottery entry',
  },
  {
    id: 'canberra-2027',
    name: 'Canberra Times Marathon Festival',
    city: 'Canberra',
    country: 'Australia',
    date: '2027-04-11',
    dateConfirmed: true,
    startTime: '06:15',
    timezone: 'Australia/Sydney',
    lat: -35.3012,
    lng: 149.1301,
    url: 'https://raceroster.com/events/2027/139094/the-canberra-times-marathon-festival-2027',
    finishers: 2374,
    knownFor: 'Australia\'s oldest city marathon: crisp autumn laps of Lake Burley Griffin and the Parliamentary Triangle from a dark, cold 06:15 start',
  },
  {
    id: 'vienna-2027',
    name: 'Vienna City Marathon',
    city: 'Vienna',
    country: 'Austria',
    date: '2027-04-18',
    dateConfirmed: true,
    startTime: '09:00',
    timezone: 'Europe/Vienna',
    lat: 48.2318,
    lng: 16.4146,
    url: 'https://www.vienna-marathon.com/',
    finishers: 8657,
    knownFor: 'Starts by UNO City and crosses the Reichsbrücke, past Schönbrunn to a Ring finish by the Burgtheater; generous 6.5h cutoff, can turn warm',
  },
  {
    id: 'boston-2027',
    name: 'Boston Marathon presented by Bank of America',
    city: 'Boston',
    country: 'USA',
    date: '2027-04-19',
    dateConfirmed: true,
    startTime: '09:06',
    startTimeConfirmed: false,
    timezone: 'America/New_York',
    lat: 42.2298,
    lng: -71.5182,
    url: 'https://www.baa.org',
    finishers: 29021,
    major: true,
    knownFor: 'Oldest annual marathon with a BQ-only field; the net downhill trashes quads before the Newton hills, and late-morning starts can run warm',
  },
  {
    id: 'london-2027',
    name: 'TCS London Marathon',
    city: 'London',
    country: 'UK',
    date: '2027-04-24',
    dateConfirmed: true,
    startTime: '08:00',
    startTimeConfirmed: false,
    timezone: 'Europe/London',
    lat: 51.474,
    lng: 0.0066,
    url: 'https://www.londonmarathonevents.co.uk/london-marathon',
    finishers: 59830,
    major: true,
    knownFor: 'World-record field and unmatched charity atmosphere from Greenwich/Blackheath to The Mall; the 2027 "Double" brings 100,000 runners over two days',
  },
  {
    id: 'copenhagen-2027',
    name: 'Copenhagen Marathon',
    city: 'Copenhagen',
    country: 'Denmark',
    date: '2027-05-09',
    dateConfirmed: true,
    startTime: '09:30',
    timezone: 'Europe/Copenhagen',
    lat: 55.703,
    lng: 12.5735,
    url: 'https://copenhagenmarathon.dk/en/',
    finishers: 18508,
    knownFor: 'Flat loop through Indre By, Christianshavn and Nørrebro from a Fælledparken start/finish; 80k+ applicants, so plan entry early',
  },
  {
    id: 'capetown-2027',
    name: 'Sanlam Cape Town Marathon',
    city: 'Cape Town',
    country: 'South Africa',
    date: '2027-05-23',
    dateConfirmed: true,
    startTime: '08:00',
    startTimeConfirmed: false,
    timezone: 'Africa/Johannesburg',
    lat: -33.9048,
    lng: 18.41,
    url: 'https://capetownmarathon.com',
    finishers: 27000,
    major: true,
    knownFor: 'Africa\'s first Abbott World Marathon Major (debut Major edition 2027), with a Table Mountain backdrop and a fast course (2:04:55 record in 2026)',
  },
  {
    id: 'stockholm-2027',
    name: 'adidas Stockholm Marathon',
    city: 'Stockholm',
    country: 'Sweden',
    date: '2027-05-29',
    dateConfirmed: true,
    startTime: '12:00',
    timezone: 'Europe/Stockholm',
    lat: 59.3462,
    lng: 18.0817,
    url: 'https://stockholmmarathon.se/eng/',
    finishers: 19000,
    knownFor: 'Saturday midday start, so heat can bite; scenic waterfront course with Västerbron climbs, finishing inside the 1912 Olympic Stadium',
  },
  {
    id: 'brisbane-2027',
    name: 'Brisbane Marathon Festival',
    city: 'Brisbane',
    country: 'Australia',
    date: '2027-06-06',
    dateConfirmed: true,
    startTime: '06:00',
    timezone: 'Australia/Brisbane',
    lat: -27.4728,
    lng: 153.0268,
    url: 'https://www.brisbanemarathon.com.au/',
    finishers: 2565,
    knownFor: 'George St start, a run over the fully closed Story Bridge and a City Botanic Gardens finish; mid-size and low-hassle',
  },
  {
    id: 'gold-coast-2027',
    name: 'Gold Coast Marathon',
    city: 'Gold Coast',
    country: 'Australia',
    date: '2027-07-04',
    dateConfirmed: true,
    startTime: '06:15',
    startTimeConfirmed: false,
    timezone: 'Australia/Brisbane',
    lat: -27.968,
    lng: 153.415,
    url: 'https://goldcoastmarathon.com.au/races/marathon/',
    finishers: 14500,
    knownFor: 'Flat, fast beachfront course (62 m gain) in cool winter air; Australia\'s best PB/BQ marathon, so enter when entries open in December',
  },
  {
    id: 'sunshine-coast-2027',
    name: 'Sunshine Coast Marathon',
    city: 'Sunshine Coast',
    country: 'Australia',
    date: '2027-08-01',
    dateConfirmed: true,
    startTime: '06:00',
    timezone: 'Australia/Brisbane',
    lat: -26.672,
    lng: 153.1068,
    url: 'https://sunshinecoastmarathon.com.au/',
    finishers: 2924,
    knownFor: 'Flat coastal out-and-back from Alexandra Headland along the Mooloolaba esplanade; a relaxed winter race that pairs well with a beach holiday',
  },
  {
    id: 'sydney-2027',
    name: 'TCS Sydney Marathon presented by ASICS',
    city: 'Sydney',
    country: 'Australia',
    date: '2027-08-29',
    dateConfirmed: true,
    startTime: '06:30',
    timezone: 'Australia/Sydney',
    lat: -33.8358,
    lng: 151.2075,
    url: 'https://www.tcssydneymarathon.com',
    finishers: 36291,
    major: true,
    knownFor: 'Newest major (2025): Miller St start, Harbour Bridge crossing and Opera House finish; hilly (313 m gain) and an early start, so not a PB course',
  },
  {
    id: 'berlin-2027',
    name: 'GENERALI BERLIN-MARATHON',
    city: 'Berlin',
    country: 'Germany',
    date: '2027-09-26',
    dateConfirmed: true,
    startTime: '09:15',
    startTimeConfirmed: false,
    timezone: 'Europe/Berlin',
    lat: 52.515,
    lng: 13.366,
    url: 'https://www.bmw-berlin-marathon.com/en/',
    finishers: 50012,
    major: true,
    knownFor: 'Fastest course on earth and the world-record venue, with a Brandenburg Gate finish; formerly the BMW Berlin Marathon, Generali title sponsor from 2027',
  },
  {
    id: 'chicago-2027',
    name: 'Bank of America Chicago Marathon',
    city: 'Chicago',
    country: 'USA',
    date: '2027-10-10',
    dateConfirmed: true,
    startTime: '07:30',
    startTimeConfirmed: false,
    timezone: 'America/Chicago',
    lat: 41.8807,
    lng: -87.6206,
    url: 'https://www.chicagomarathon.com',
    finishers: 54200,
    major: true,
    knownFor: '49th running; flattest major and a PB course; applications open 8 Oct 2026 (draw or guaranteed entry)',
  },
  {
    id: 'twin-cities-2027',
    name: 'Medtronic Twin Cities Marathon',
    city: 'Minneapolis-Saint Paul',
    country: 'USA',
    date: '2027-10-17',
    dateConfirmed: true,
    startTime: '08:00',
    startTimeConfirmed: false,
    timezone: 'America/Chicago',
    lat: 44.975,
    lng: -93.262,
    url: 'https://www.tcmevents.org/',
    finishers: 7025,
    knownFor: 'Lakes-and-river course, moved later in October to escape the heat that cancelled the 2023 race',
  },
  {
    id: 'dublin-2027',
    name: 'Irish Life Dublin Marathon',
    city: 'Dublin',
    country: 'Ireland',
    date: '2027-10-24',
    dateConfirmed: true,
    startTime: '08:45',
    timezone: 'Europe/Dublin',
    lat: 53.3348,
    lng: -6.255,
    url: 'https://irishlifedublinmarathon.ie/2027-event-dates-entry-information/',
    finishers: 18500,
    knownFor: '46th running; ballot opens 12 Nov 2026 (EUR 130 entry); big crowds and a Phoenix Park loop',
  },
  {
    id: 'amsterdam-2027',
    name: 'TCS Amsterdam Marathon',
    city: 'Amsterdam',
    country: 'Netherlands',
    date: '2027-10-31',
    dateConfirmed: true,
    startTime: '09:00',
    startTimeConfirmed: false,
    timezone: 'Europe/Amsterdam',
    lat: 52.3433,
    lng: 4.8544,
    url: 'https://www.tcsamsterdammarathon.nl/programma',
    finishers: 23300,
    knownFor: 'Olympic Stadium start/finish loop; the 2027 edition falls two weeks later than usual',
  },
];
